import MetricsChangeDialog from './MetricsChangeDialog';

export default MetricsChangeDialog;
